import Aplicacao from './paginas/Aplicacao.svelte';

const aplicacao = new Aplicacao ({
	target: document.body
});

export default aplicacao;

document.addEventListener("contextmenu", evento => {
	let elementoPaiAtivo = document.activeElement.parentElement;

	if (elementoPaiAtivo.classList != 'ck ck-editor__main')
		evento.preventDefault();
});